<template>
  <div class="tooltip vue-ctrl" @click.stop="onClick" ref="toolEl">
    <div class="content" v-html="actualContent" v-if="isVisible"></div>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: ["content"],
  data() {
    return {
      isVisible: false,
      actualContent: ""
    }
  },
  computed: {
    tooltipContent() {

    }
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside)
    document.addEventListener('touchstart', this.onClickOutside)
    this.$root.$on("tooltip-displayed", (sender) => {
      if (sender !== this) this.isVisible = false;
    });

  },
  destroyed() {
    document.removeEventListener('click', this.onClickOutside)
    document.removeEventListener('touchstart', this.onClickOutside)
  },
  methods: {
    toggleTooltip() {
      this.isVisible = !this.isVisible;
      if (this.isVisible) {
        this.$root.$emit("tooltip-displayed", this);
        this.$nextTick(() => {
          //we calculate here the left coordinate, so that it does not go outside the screen
          let element = this.$refs.toolEl.querySelector(".content");
          let width = element.offsetWidth;
          let viewportWidth = document.body.offsetWidth;
          let left = element.getBoundingClientRect().left;
          if (left + width > viewportWidth) { //we're assuming here that the tooltip can't be larger than the viewport, due to CSS
            element.style.left = `${viewportWidth - width - left}px`;
          } else {
            element.style.left = "10px";
          }
        });
      }
    },
    onClick(e) {
      e.stopPropagation();
      if (!this.content) return; //we don't display the tooltip if there's no content

      if (typeof (this.content) === "function") {
        //we assume content() returns a promise
        this.content().then(res => {
          this.actualContent = res;
          this.toggleTooltip();
        }).catch(err => {
          console.error(err.message);
        });
      } else {
        this.actualContent = this.content;
        this.toggleTooltip();
      }

    },
    onClickOutside(e) {
      e.stopPropagation()
      if (!this.$refs.toolEl.contains(e.target)) {
        this.isVisible = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tooltip {
  width: 23px;
  height: 23px;
  margin-left: 10px;
  margin-top: 6px;
  background-image: url("data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2032_11252)'%3E%3Cpath d='M12.3799 22C6.85688 22 2.37988 17.523 2.37988 12C2.37988 6.477 6.85688 2 12.3799 2C17.9029 2 22.3799 6.477 22.3799 12C22.3799 17.523 17.9029 22 12.3799 22ZM12.3799 20C14.5016 20 16.5364 19.1571 18.0367 17.6569C19.537 16.1566 20.3799 14.1217 20.3799 12C20.3799 9.87827 19.537 7.84344 18.0367 6.34315C16.5364 4.84285 14.5016 4 12.3799 4C10.2582 4 8.22332 4.84285 6.72303 6.34315C5.22274 7.84344 4.37988 9.87827 4.37988 12C4.37988 14.1217 5.22274 16.1566 6.72303 17.6569C8.22332 19.1571 10.2582 20 12.3799 20ZM11.3799 7H13.3799V9H11.3799V7ZM11.3799 11H13.3799V17H11.3799V11Z' fill='%232655FF'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2032_11252'%3E%3Crect width='24' height='24' fill='white' transform='translate(0.379883)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");  background-size: 23px 23px;
  position: relative;
  cursor: pointer;
}

.tooltip.small {
  width: 14px;
  height: 14px;
  background-size: 14px 14px;
  margin-top: 0;
  margin-left: 8px;
}

.content {
  position: absolute;
  max-width: 600px;
  min-width: 300px;
  bottom: 30px;
  box-shadow: 3px 3px 3px 0px rgba(100, 100, 100, 0.75);
  border-radius: 5px;
  padding: 10px;
  background-color: #2655FF;
  color: white;
  font-size: 80%;
  z-index: 100;
  overflow-wrap: break-word;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
}

@media screen and (max-width: 600px) {
  .tooltip {
    position: relative;
  }

  .content {
    position: absolute;
    left: 10px;
    right: 10px;
    max-width: 95vw;
  }
}
</style>